import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { BplogsComponent } from './components/search/bplogs/bplogs.component'
import { CompanylogsComponent } from './components/search/companylogs/companylogs.component'
import { CompanyComponent } from './components/config/company/company.component'
import { AlertComponent } from './components/config/alert/alert.component'
import { AssignAlertToCompanyComponent} from './components/config/assign/assign-alert-to-company/assign-alert-to-company.component'
import { ManagerComponent } from './components/config/manager/manager.component'
import { ManagerByCompanyComponent } from './components/config/manager-by-company/manager-by-company.component'
import { SupplierlogsComponent } from './components/search/supplierlogs/supplierlogs.component'
import { LoginComponent } from '././components/shared/login/login.component'
import { AuthGuard } from './guard/auth.guard';
import { PermsGuard } from './guard/perms.guard';

const routes: Routes = [
  { path: '', component: LoginComponent, canActivate:[AuthGuard], runGuardsAndResolvers:'always' },
  { path: 'search/bplog', component: BplogsComponent, canActivate:[AuthGuard, PermsGuard] },
  { path: 'search/companylog', component: CompanylogsComponent, canActivate:[AuthGuard, PermsGuard] },
  { path: 'search/supplierlog', component: SupplierlogsComponent, canActivate:[AuthGuard, PermsGuard] },
  { path: 'documents', pathMatch: 'full', redirectTo: ''},
  { path: 'config/Alert', component: AlertComponent, canActivate:[AuthGuard, PermsGuard] },
  { path: 'config/Company', component: CompanyComponent, canActivate:[AuthGuard, PermsGuard] },
  { path: 'config/AssingAlertToCompany', component: AssignAlertToCompanyComponent, canActivate:[AuthGuard, PermsGuard] }, 
  { path: 'config/Manager', component: ManagerComponent, canActivate:[AuthGuard, PermsGuard] }, 
  { path: 'config/ManagerByCompany', component: ManagerByCompanyComponent, canActivate:[AuthGuard, PermsGuard] },
  { path: 'login/:user', component: LoginComponent },
  { path: 'home', pathMatch: 'full', redirectTo: ''},
  { path: '**', pathMatch: 'full', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
